export default __webpack_public_path__ + "static/media/BearLabTwitter.e36db2b2.png";